"use strict";
// special thanks to https://github.com/bernatvadell/ts-buffer-serializer
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerializerUtil = void 0;
const fields_1 = __importDefault(require("./types/fields"));
const types_1 = __importDefault(require("./types"));
const serializer_1 = require("./serializer");
class SerializerUtil {
    constructor() {
        this.fields = fields_1.default;
        this.types = types_1.default;
    }
    serialize(object) {
        return serializer_1.Serializer.serialize(object).toString("hex");
    }
    deserialize(classType, data) {
        return serializer_1.Serializer.deserialize(classType, data);
    }
}
exports.SerializerUtil = SerializerUtil;
//# sourceMappingURL=index.js.map